import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { TdBuilderUsageIndividualReportComponent } from './td-builder-usage-individual/td-builder-usage-individual.reports.component';
import { TdBuilderUsageMetricReportComponent } from './td-builder-usage-metric/td-builder-usage-metric.reports.component';
import { TdComplianceReportComponent } from './td-compliance/td-compliance.reports.component';
import { TdDailyHuddleReportComponent } from './td-daily-huddle/td-daily-huddle.reports.component';
import { TdOffersReportComponent } from './td-offers/td-offers.reports.component';
import { RxRReportComponent } from './td-rxr/rxr.reports.component';
import { ReportTbytComponent } from './td-tbyt/reports_tbyt.component';
import { UserLoginReportsComponent } from './user-login.reports.component';

export const ReportsRoutes: Routes = [
    {
        path: 'reports',
        canActivate: [AuthService],
        canActivateChild: [AuthService],
        children: [
            {
                path: 'user/login',
                component: UserLoginReportsComponent,
            },
            {
                path: 'dailyhuddle',
                component: TdDailyHuddleReportComponent,
            },
            {
                path: 'reporttbyt',
                component: ReportTbytComponent,
            },
            {
                path: 'rxr',
                component: RxRReportComponent,
            },
            {
                path: 'compliance',
                component: TdComplianceReportComponent,
            },
            {
                path: 'offers',
                component: TdOffersReportComponent,
            },
            {
                path: 'buildermetric',
                component: TdBuilderUsageMetricReportComponent,
            },
            {
                path: 'builderindividual',
                component: TdBuilderUsageIndividualReportComponent,
            },
        ],
    },
];
